import { Alert } from 'antd';
import { InspectionReportReview } from '@/shared/types/inspectionReportReview.types';

interface PendingCorrectionAlertProps {
  pendingReview: InspectionReportReview | null;
}
export function PendingCorrectionAlert({ pendingReview }: PendingCorrectionAlertProps) {
  if (!pendingReview) return null;

  return (
    <Alert
      message="Correções Pendentes"
      description={
        <div>
          <p style={{ margin: 0, marginBottom: 8 }}>
            {pendingReview.reviewerType === 'Provider' ? 'A Prestadora' : 'O Banco'} rejeitou
            o laudo e apontou{' '}
            <strong>{pendingReview.fieldCorrections?.length || 0} campo(s)</strong> para
            correção.
          </p>
          {pendingReview.generalComments && (
            <p style={{ margin: 0, fontStyle: 'italic' }}>
              Comentário: "{pendingReview.generalComments}"
            </p>
          )}
        </div>
      }
      type="warning"
      showIcon
      style={{ marginBottom: 16 }}
    />
  );
}
